export const DeviceType = {
  Android: 1,
  IOS: 2
}

export const SubscriptionType = {
  Email: 0,
  PushNotificaion: 1,
  TextMessage: 2,
  WhatsappNotification: 3
}

export const ClientCode = '1FEBE701BFAC4371991C6A047D00FEC2'

export const routeNotificationContentType = {
  CAMPAIGN: 'dashboard',
  REPORT: 'publishedReports',
  LEAD: 'leads',
  BALANCE: 'wallet',
  WALLET: 'wallet'
}